const infoCarouselStrings = {
  stepPosition: 'Step {{current}} of {{total}}',
};

export default infoCarouselStrings;
